import React from 'react'
import {PanelWrapper} from "./PanelWrapper";
import {Card} from "../Card";
import {isSelected, loadingSkeleton} from '../EntitySelectorModal.helpers'
import {EmptyState} from "../EmptyState";
import useGetPlaces from "../../../hooks/api/useGetPlaces";
import {Place} from "../../../types/Place";
import {ENTITY_TYPES} from "../../EntitySelector/EntitySelector.constants";
import {SelectedItemsData} from "../../EntitySelector/EntitySelector.types";

// Types ----

type PlacesPanelProps = {
  onSelect: (place: Place) => void
  selectedItems: SelectedItemsData
  isMaxSelected?: boolean
}

// Component ----

function PlacesPanel({ onSelect, selectedItems, isMaxSelected }: PlacesPanelProps) {
  const {data: places, isLoading} = useGetPlaces({
    perPage: 1000,
  });

  return (
    <PanelWrapper isLoading={isLoading}>
      {isLoading ?
        loadingSkeleton :
        <>
          {!!places?.data?.length ? places?.data.map(place => {
              const selected = isSelected(place, ENTITY_TYPES.PLACE, selectedItems);

              return (
                <Card
                  key={place.id}
                  onClick={() => onSelect(place)}
                  heading={place.name}
                  footer={place.address?.city}
                  active={selected}
                  disabled={isMaxSelected && !selected}
                />
              )
            }) :
            <EmptyState />
          }
        </>
      }
    </PanelWrapper>
  );
}

export {PlacesPanel};